import React from 'react';
import { Box, SxProps, TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { Order } from '..';

export interface EnhancedTableHeadCell {
	id: string;
	align?: 'center' | 'right' | 'left' | 'inherit' | 'justify';
	sortable?: boolean;
	label: string;
	colSpan?: number;
}

interface HeadProps {
	cells: EnhancedTableHeadCell[];
	order: Order;
	orderBy: string;
	//optional, but won't be sortable without
	onRequestSort?: (event: React.MouseEvent, property: string) => void;
}

export const TableHeadCellSx: SxProps = { backgroundColor: 'background.paper', fontWeight: 'bold' };

const EnhancedTableHead: React.FC<HeadProps> = ({ cells, order, orderBy, onRequestSort }) => {
	const createSortHandler = (property: string) => (event: React.MouseEvent) => {
		if (onRequestSort) {
			onRequestSort(event, property);
		}
	};

	return (
		<TableHead>
			<TableRow>
				{cells.map((cell) => (
					<TableCell
						key={cell.id}
						align={cell.align}
						sortDirection={orderBy === cell.id ? order : false}
						sx={TableHeadCellSx}
						colSpan={cell.colSpan}
					>
						{cell.sortable ? (
							<TableSortLabel
								active={orderBy === cell.id}
								direction={orderBy === cell.id ? order : 'asc'}
								onClick={createSortHandler(cell.id)}
							>
								<Typography fontWeight="bold">{cell.label}</Typography>
								{orderBy === cell.id && (
									<Box component="span" sx={visuallyHidden}>
										{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
									</Box>
								)}
							</TableSortLabel>
						) : (
							<Typography fontWeight="bold">{cell.label}</Typography>
						)}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
};

export default EnhancedTableHead;
